import { render, staticRenderFns } from "./SubProjectApp.vue?vue&type=template&id=e399c0d2&scoped=true&"
import script from "./SubProjectApp.vue?vue&type=script&lang=js&"
export * from "./SubProjectApp.vue?vue&type=script&lang=js&"
import style0 from "./SubProjectApp.vue?vue&type=style&index=0&id=e399c0d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e399c0d2",
  null
  
)

export default component.exports